import React, { createContext, useState } from "react";

export const AuthContext = createContext();
const AuthProvider = ({ children }) => {
  const [buyer, setBuyer] = useState({
    buyerName: "",
    address: "",
    discount: 0,
    previousDue: 0,
  });
  console.log(buyer);
  const authInfo = { buyer, setBuyer };
  return (
    <AuthContext.Provider value={authInfo}>{children}</AuthContext.Provider>
  );
};

export default AuthProvider;
